import { render, staticRenderFns } from "./preview_item.vue?vue&type=template&id=2c4cff36&scoped=true&lang=pug"
import script from "./preview_item.vue?vue&type=script&lang=js"
export * from "./preview_item.vue?vue&type=script&lang=js"
import style0 from "./preview_item.vue?vue&type=style&index=0&id=2c4cff36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4cff36",
  null
  
)

export default component.exports